import { format, parseISO } from 'date-fns'

export const useCurrencyFormatter = (language = 'fi-FI') => {
  return new Intl.NumberFormat(language, { style: 'currency', currency: 'EUR' })
}

export const usePercentageFormatter = (language = 'fi-FI') => {
  return new Intl.NumberFormat(language, { maximumFractionDigits: 1 })
}

export const formatDateString = (dateString: string) => {
  return format(parseISO(dateString), 'dd.MM.yyyy')
}

export const formatDate = (date: Date) => {
  return format(date, 'dd.MM.yyyy')
}

export const formatDateForOrder = (date: Date) => {
  return format(date, 'eeeeee dd.MM yyyy')
}

export const formatDateTimeString = (dateString: string) => {
  return format(parseISO(dateString), 'dd.MM.yyyy HH:mm')
}

export const formatDateForCalendar = (dateString: string) => {
  if (!dateString) return
  return format(parseISO(dateString), 'yyyy-MM-dd')
}
